import React, { useContext } from "react";
import SelectCategory from "./SelectCategory";
import { LangContext } from "../App";
import search from "../assets/search.svg";

export default function Form(props) {
  const { onSubmitForm, onMultipleSelect, selectedData } = props;
  const lang = useContext(LangContext);

  return (
    <form id="search-form">
      <div className="form-row">
        <SelectCategory onMultiple={onMultipleSelect} selected={selectedData} />
      </div>
      <div className="form-row form-row-flex">
        <div className="search-input">
          <label className="search-label" htmlFor="search-term">
            {lang === "sk" ? "Zadajte kľúčové slovo" : "Add keyword"}
          </label>
          <input
            type="text"
            id="search-term"
            name="search-term"
            placeholder={
              lang === "sk" ? "napr. ľudské práva" : "e.g. human rights"
            }
          />
        </div>
        <button
          className="search-btn btn red-btn"
          type="submit"
          onClick={onSubmitForm}
        >
          <img src={search} alt={lang === "sk" ? "Hľadať" : "Search"} />
          {lang === "sk" ? "Hľadať" : "Search"}
        </button>
      </div>
    </form>
  );
}
